import { render, staticRenderFns } from "./STableCell.vue?vue&type=template&id=04ceb905&scoped=true&"
import script from "./STableCell.vue?vue&type=script&lang=js&"
export * from "./STableCell.vue?vue&type=script&lang=js&"
import style0 from "./STableCell.vue?vue&type=style&index=0&id=04ceb905&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ceb905",
  null
  
)

export default component.exports